const SaveIconUnselected = (props: { color?: string }) => {
    return (
        <svg width="22px" height="21px" viewBox="0 0 22 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Save</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobDetailFlyout1920Copy2" transform="translate(-1384, -32)" fill="none" stroke={props.color ?? "#000000"} strokeWidth="2">
                    <path d="M1393.81029,51.5742323 C1394.50687,52.1419226 1395.49313,52.1419226 1396.18971,51.5742323 C1398.84009,49.4127968 1405,43.9264616 1405,39.6216443 C1405,34.3970886 1399.42436,32.1223156 1396.45574,35.8173172 C1395.7089,36.7480885 1394.2911,36.7480885 1393.54426,35.8173172 C1390.57564,32.1223156 1385,34.3970886 1385,39.6216443 C1385,43.9264616 1391.15991,49.4127968 1393.81029,51.5742323 Z" id="Stroke90"></path>
                </g>
            </g>
        </svg>
    );
}

export default SaveIconUnselected;
